import {
  GET_GOLDSMITH_PURCHASES_REQUEST,
  GET_GOLDSMITH_PURCHASES_SUCCESS,
  GET_GOLDSMITH_PURCHASES_FAILURE,
  GET_GOLDSMITH_PURCHASE_REQUEST,
  GET_GOLDSMITH_PURCHASE_SUCCESS,
  GET_GOLDSMITH_PURCHASE_FAILURE,
  CREATE_GOLDSMITH_PURCHASE_REQUEST,
  CREATE_GOLDSMITH_PURCHASE_SUCCESS,
  CREATE_GOLDSMITH_PURCHASE_FAILURE,
  UPDATE_GOLDSMITH_PURCHASE_REQUEST,
  UPDATE_GOLDSMITH_PURCHASE_SUCCESS,
  UPDATE_GOLDSMITH_PURCHASE_FAILURE,
  GET_TODAY_GOLD_RATE_REQUEST,
  GET_TODAY_GOLD_RATE_SUCCESS,
  GET_TODAY_GOLD_RATE_FAILURE,
  GET_PURCHASE_PAYMENTS_REQUEST,
  GET_PURCHASE_PAYMENTS_SUCCESS,
  GET_PURCHASE_PAYMENTS_FAILURE,
} from '../types';

const initialState = {
  purchases: [],
  currentPurchase: null,
  todayGoldRate: null,
  purchasePayments: {
    payments: [],
    paymentModeTotals: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      itemsPerPage: 10,
    }
  },
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
  loading: false,
  error: null,
};

const goldsmithPurchaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GOLDSMITH_PURCHASES_REQUEST:
    case CREATE_GOLDSMITH_PURCHASE_REQUEST:
    case UPDATE_GOLDSMITH_PURCHASE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_GOLDSMITH_PURCHASES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        purchases: action.payload.purchases || [],
        pagination: action.payload.pagination || state.pagination,
      };

    case CREATE_GOLDSMITH_PURCHASE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        purchases: [action.payload, ...state.purchases],
      };

    case UPDATE_GOLDSMITH_PURCHASE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        purchases: state.purchases.map(purchase =>
          purchase.id === action.payload.id ? action.payload : purchase
        ),
      };

    case GET_GOLDSMITH_PURCHASES_FAILURE:
    case CREATE_GOLDSMITH_PURCHASE_FAILURE:
    case UPDATE_GOLDSMITH_PURCHASE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_GOLDSMITH_PURCHASE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        currentPurchase: null,
      };

    case GET_GOLDSMITH_PURCHASE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        currentPurchase: action.payload,
      };

    case GET_GOLDSMITH_PURCHASE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        currentPurchase: null,
      };

    case GET_TODAY_GOLD_RATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_TODAY_GOLD_RATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        todayGoldRate: action.payload,
      };

    case GET_TODAY_GOLD_RATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        todayGoldRate: null,
      };

    case GET_PURCHASE_PAYMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_PURCHASE_PAYMENTS_SUCCESS:
      {
        const payload = action.payload || {};
        const candidates = [
          payload?.data?.payments,
          payload?.payments,
          payload?.data?.purchases,
          payload?.purchases,
          payload?.data?.payments?.rows,
          payload?.payments?.rows,
          payload?.data?.payments?.items,
          payload?.payments?.items,
        ];
        const resolvedList = candidates.find(Array.isArray) || [];
        const totalsCandidates = [
          payload?.data?.paymentModeTotals,
          payload?.paymentModeTotals,
        ];
        const resolvedTotals = totalsCandidates.find(Array.isArray) || [];
        const resolvedPagination = payload?.pagination || payload?.data?.pagination || state.purchasePayments.pagination;
      return {
        ...state,
        loading: false,
        error: null,
        purchasePayments: {
            payments: resolvedList,
            paymentModeTotals: resolvedTotals,
            pagination: resolvedPagination,
        },
      };
      }

    case GET_PURCHASE_PAYMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default goldsmithPurchaseReducer;
